import React from "react";
import { Helmet } from "react-helmet-async";
import { match as Match } from "react-router-dom";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../utils";
import EnterpriseForm from "../form";
import PageSubheader from "../../../components/PageSubheader";

interface Props {
  match: Match;
  intl: IntlShape;
  backURL: string;
}

const EnterpriseUpdate = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ id: "page.enterprise.update.document.title" })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-enterprise-update"
        goBackURL={backURL}
      />

      <EnterpriseForm {...props} edition />
    </>
  );
};

export default withOneColLayout(injectIntl(EnterpriseUpdate));
